import React from "react";
import { Controller, useFormContext } from "react-hook-form";

function RHFInputController({ RHFname, type, placeholder, className }) {
  const methods = useFormContext();
  const { control } = methods;

  return (
    <Controller
      name={RHFname}
      control={control}
      render={({ field: { onChange, value } }) => (
        <>
          <input
            type={type}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            className={className}
            required
          />
        </>
      )}
    />
  );
}

export default RHFInputController;
